import React from "react";
import { FilterState } from "../../adapters/insights-agent/state/AppState.ts";
import { Chip } from "../../ui-library/Chip/Chip.tsx";
import { makeChipValues } from "./makeChipValues.ts";
import styles from "./FilterChips.module.css";
export const FilterChips: React.FC<{
  filterState: FilterState;
  onDelete?: (newFilterState: FilterState) => void;
}> = (props) => {
  const chipValues = makeChipValues(props.filterState);
  return (
    <div className={styles.FilterChips}>
      {chipValues.map((chipValue) => (
        <Chip
          key={chipValue.label}
          onDelete={() => {
            const newFilterState = chipValue.removeChipValue(props.filterState);
            props.onDelete?.(newFilterState);
          }}
        >
          {chipValue.label}
        </Chip>
      ))}
    </div>
  );
};
